export default class MediaPreviewDTO {

    public id: number;
    public filename: string | undefined;
    public cloudfrontUrl: string | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'];
        this.filename = data['filename'];
        this.cloudfrontUrl = data['cloudfrontUrl'];
    }
}